import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, TextField as MuiTextField, CircularProgress } from '@material-ui/core';

// Read-only block: a multi-line text area of ads.txt lines + a Copy button.
function AdstxtBlock({ label, lines }) {
  const text = (lines || []).join('\n');
  const copy = () => {
    navigator.clipboard.writeText(text).catch(() => {});
  };
  return (
    <Box style={{ marginBottom: 24 }}>
      <Typography variant="subtitle1" style={{ fontWeight: 600 }}>{label}</Typography>
      <Button onClick={copy} variant="outlined" style={{ marginTop: 8 }} disabled={!text}>Copy</Button>
      <MuiTextField
        value={text}
        multiline
        fullWidth
        minRows={6}
        InputProps={{ readOnly: true, style: { fontFamily: 'monospace', fontSize: 12 } }}
      />      
    </Box>
  );
}

// Fetches and renders the ads.txt / app-ads.txt lines a publisher must implement.
export function AdstxtComponent({ publisherCode }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!publisherCode) { setLoading(false); return; }
    setLoading(true);
    const token = localStorage.getItem('token');
    fetch(`${window.nobid_endpoint}/publishers/${publisherCode}/adstxt`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
      .then(result => { setData(result); setLoading(false); })
      .catch(e => { setError(e.message); setLoading(false); });
  }, [publisherCode]);

  if (loading) return <CircularProgress size={20} />;
  if (error) return <Typography color="error">Failed to load ads.txt lines: {error}</Typography>;
  if (!data) return <Typography>No ads.txt data.</Typography>;

  return (
    <div>
      {(data.warnings || []).map((w, i) => (
        <Box key={i} style={{ background: '#5d4037', color: '#fff', padding: '8px 12px', borderRadius: 4, marginBottom: 12 }}>
          <Typography variant="body2">⚠ {w}</Typography>
        </Box>
      ))}
      <AdstxtBlock label="ads.txt" lines={data.ads_txt} />
      <AdstxtBlock label="app-ads.txt" lines={data.app_ads_txt} />
    </div>
  );
}

export default AdstxtComponent;
